import { DisplayAdContainer } from '../../containers/ads/displayAdContainer.jsx';
import PropTypes from 'prop-types';
import React from 'react';
import { getAdByWidthHeight } from '../../components/common/ads';

export const DisplayAdWidget = DisplayAdContainer(({ width, height, slotId, adLoaded, displayDefaultAd, adEnabled }) => {
    const defaultAd = getAdByWidthHeight(width, height);
    const showDefaultAd = displayDefaultAd && !adLoaded && adEnabled;

    return (
        <div style={styles.container}>
            { adEnabled && <div>
                <div id={slotId} />
                {
                    showDefaultAd && <a href={defaultAd.href}>
                        <img
                            alt='Default Ad'
                            width={width}
                            height={height}
                            src={defaultAd.src}
                        />
                    </a>
                }
            </div> }
        </div>
    );
});

const styles = {
    container: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center'
    }
};

DisplayAdWidget.propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    slotId: PropTypes.string,
    adEnabled: PropTypes.bool,
    adLoaded: PropTypes.bool,
    displayDefaultAd: PropTypes.bool
};

DisplayAdWidget.defaultProps = {
    displayDefaultAd: true,
    adEnabled: true
};
